"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type PopoverArrowProps = ComponentProps<typeof PopoverPrimitive.Arrow>;

const Arrow = ({ className, width = 12, height = 6, ...props }: PopoverArrowProps) => (
  <PopoverPrimitive.Arrow
    className={cn("-translate-y-px fill-white", className)}
    width={width}
    height={height}
    {...props}
  />
);
Arrow.displayName = PopoverPrimitive.Arrow.displayName;

export default Arrow;
